import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/views/Main'

Vue.use(VueRouter)

const routes = [
    {
        path: "/splash",
        name: "splash",
        component: () => import("@/views/Splash"),
    },
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/Login"),
    },
    {
        path: "/loginOthers",
        name: "loginOthers",
        component: () => import("@/views/LoginOthers"),
    },
    {
        path: "/Unauthorized",
        name: "Unauthorized",
        component: () => import("@/views/Unauthorized"),
    },
    {
        path: "/",
        name: "系统管理",
        component: Main,
        children: [{
            path: '/dashboard',
            component: () => import("@/views/Dashboard"),
            name: '数据看板详情'
        },{
            path: '/notice/list',
            component: () => import("@/views/notice/list"),
            name: '站内消息列表'
        },{
            path: '/inquiry/list',
            component: () => import("@/views/inquiry/list"),
            name: '采购询价列表'
        },{
            path: '/inquiry/add',
            component: () => import("@/views/inquiry/add"),
            name: '采购询价单新增'
        },{
            path: '/inquiry/edit',
            component: () => import("@/views/inquiry/edit"),
            name: '采购询价单编辑'
        },{
            path: '/quote/list',
            component: () => import("@/views/quote/list"),
            name: '报价管理列表'
        },{
            path: '/quote/edit',
            component: () => import("@/views/quote/edit"),
            name: 'quoteEdit'
        },{
            path: '/declassifying/list',
            component: () => import("@/views/declassifying/list"),
            name: '报价解密列表'
        },{
            path: '/declassifying/edit',
            component: () => import("@/views/declassifying/edit"),
            name: 'declassifyingEdit'
        },{
            path: '/declassifying/view',
            component: () => import("@/views/declassifying/view"),
            name: 'declassifyingView'
        },{
            path: '/declassifying/supplement',
            component: () => import("@/views/declassifying/supplement"),
            name: 'declassifyingSupplement'
        },{
            path: '/monitoring/list',
            component: () => import("@/views/monitoring/list"),
            name: '运行监控列表'
        },{
            path: '/monitoring/view',
            component: () => import("@/views/monitoring/view"),
            name: 'monitoringView'
        },{
            path: '/adjustment/list',
            component: () => import("@/views/adjustment/list"),
            name: '调剂公示列表'
        },{
            path: "/system/supplier/list",
            component: () => import("@/views/system/supplier/list"),
            name: "供应商维护列表",
        },{
            path: "/system/category/list",
            component: () => import("@/views/system/category/list"),
            name: "物资类维护列表",
        },{
            path: "/system/approval/list",
            component: () => import("@/views/system/approval/list"),
            name: "审核管理",
        },{
            path: "/system/user/list",
            component: () => import("@/views/system/user/list"),
            name: "用户列表",
        },{
            path: "/system/role/list",
            component: () => import("@/views/system/role/list"),
            name: "角色列表",
        },{
            path: "/system/permissions/list",
            component: () => import("@/views/system/permissions/list"),
            name: "权限列表",
        },{
            path: "/system/dictionary/list",
            component: () => import("@/views/system/dictionary/list"),
            name: "数据字典",
        },{
            path: "/system/loginLog/list",
            component: () => import("@/views/system/loginLog/list"),
            name: "登录日志",
        },{
            path: "/system/operationLog/list",
            component: () => import("@/views/system/operationLog/list"),
            name: "操作日志",
        }]
    },
    {
        path: "/quartz",
        component: Main,
        name: "定时任务",
        children: [{
            path: "httpJob/list",
            component: () => import("@/views/quartz/httpJob/list"),
            name: "任务列表",
        },{
            path: "jobHistory/list",
            component: () => import("@/views/quartz/jobHistory/list"),
            name: "历史任务",
        }]
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.NODE_ENV === 'development' ? process.env.BASE_URL : '/manage',
    routes
});

router.beforeEach((to, from, next) => {
    if (to.path === '/splash') {
        next();
    } else if (to.path === '/login' || to.path === '/loginOthers') {
        window.sessionStorage.removeItem("menuItem");
        window.sessionStorage.removeItem("submenu");
        window.sessionStorage.removeItem('Authorization');
        next();
    } else {
        let Authorization = window.sessionStorage.getItem('Authorization');
        if (Authorization) {
            next();
        } else {
            next({path: '/splash'});
        }
    }
});

export default router
